import { v4 as uuidv4 } from 'uuid';
import { getTradeDataType } from '../config/constants';
import { purchaseTradeCheck, purchaseTradeInit } from '../services';

export default {
  namespace: 'purchase',
  state: {},
  effects: {
    *purchaseTradeCheck({ payload }, { call, put, select }) {
      const {
        businessType,
        paymentApplyList = [],
        orderList = [],
        contractList = [],
        operatorId,
        orderDataSource
      } = payload || {};
      const paymentApplyCodeList = paymentApplyList.map(item => item.paymentApplyCode);
      const orderCodeList = orderList.map(item => item.orderCode);
      const contractIdList = contractList.map(item => item.contractId);
      const dataType = getTradeDataType(businessType);
      const res = yield call(purchaseTradeCheck, {
        businessType,
        paymentApplyCodeList,
        orderCodeList,
        contractIdList,
        authorizer: operatorId,
        orderDataSource
      });
      const { checkStatus, checkMessage } = res || {};
      if (checkStatus === 0) {
        const successListMap = {
          payInfo: paymentApplyList,
          order: orderList,
          contract: contractList,
          other: [],
        };
        return {
          success: true,
          dataType,
          successList: successListMap[dataType],
        };
      } else if (checkStatus === 2) {
        const { fail = [], success = [] } = JSON.parse(checkMessage) || {};
        let errorList = []; // 失败列表
        let successList = []; // 成功列表
        switch (dataType) {
          case 'payInfo':
            successList = paymentApplyList.filter(item => success.includes(item.paymentApplyCode));
            break;
          case 'order':
            successList = orderList.filter(item => success.includes(item.orderCode));
            break;
          case 'contract':
            successList = contractList.filter(item => success.includes(item.contractId));
            break;
          default:
            break;
        }
        fail.forEach(item => {
          const { code, message } = item || {};
          switch (dataType) {
            case 'payInfo':
              // const paymentApplyList = paymentApplyList.find(item => item.paymentApplyCode === code);
              errorList.push({
                code,
                // name: paymentApplyList?.name || '',
                message: message || '',
              });
              break;
            case 'order':
              const order = orderList.find(item => item.orderCode === code);
              errorList.push({
                code,
                name: '',
                message: message || '',
              });
              break;
            case 'contract':
              const contract = contractList.find(item => item.contractId === code);
              errorList.push({
                code,
                name: contract?.contractName,
                message: message || '',
              });
              break;
            default:
              break;
          }
        });
        return {
          success: false,
          dataType,
          errorList,
          successList,
        };
      }
      return res;
    },
    /**
     * 交易信息初始化
     * @param {*} param0
     * @param {*} param1
     * @returns
     */
    *purchaseTradeInit({ payload }, { call, put, select }) {
      const {
        businessType,
        paymentApplyList = [],
        orderList = [],
        contractList = [],
        operatorId,
        orderDataSource,
      } = payload || {};
      const paymentApplyCodeList = paymentApplyList.map(item => item.paymentApplyCode);
      const orderCodeList = orderList.map(item => item.orderCode);
      const contractIdList = contractList.map(item => item.contractId);
      const dataType = getTradeDataType(businessType);
      const res = yield call(purchaseTradeInit, {
        businessType,
        paymentApplyCodeList,
        orderCodeList,
        contractIdList,
        authorizer: operatorId,
        orderDataSource
      });
      const { tradeInfoList = [], checkStatus = 0 } = res || {};
      if (dataType === 'order') {
        // 订单时， 额外读取 收货人信息
        // todo 该逻辑需要删除
        return {
          success: checkStatus === 0,
          tradeInfoList: tradeInfoList.map(item => {
            const { orderExpenseFormList = [], ...rest } = item || {};
            return {
              ...rest,
              orderExpenseFormList: orderExpenseFormList.map(order => {
                const currentOrder = orderList.find(item => item.orderCode === order.orderCode);
                return {
                  ...order,
                  receiver: currentOrder?.receiver || '',
                };
              }),
            };
          }),
        };
      } else {
        return {
          success: checkStatus === 0,
          tradeInfoList,
        };
      }
    },
    /**
     * 二次加工交易信息
     * @param {*} param0
     * @param {*} param1
     */
    purchaseTradeInitByExpense({ payload }) {
      const { tradeInfoList } = payload || {};
      return tradeInfoList.map(item => {
        const { receiverPOS = [], tradeAmount, ...rest } = item || {};
        return {
          ...rest,
          tradeAmount,
          receiverPOS: receiverPOS.map(pos => {
            return {
              ...pos,
              amount: tradeAmount || 0,
              indexNo: uuidv4(),
            };
          }),
          expenseFeeExtendList: [],
        };
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
